import styled, { css } from "styled-components";
import { Card } from "@material-ui/core";

export const MuiCard = styled(Card)`
  width: calc(20% - 40px / 4);
  background-color: transparent;

  ${({ theme }) => css`
    ${theme.breakpoints.down("sm")} {
      width: calc(25% - 30px / 3);
    }
  `}
  ${({ theme }) => css`
    ${theme.breakpoints.down("xs")} {
      width: calc(33.3333% - 20px / 2);
    }
  `} 

  .card-media {
    border-radius: 10px;
  }

  .card-content {
    color: #fff;
    padding: 6px 8px;
    position: relative;
    p {
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .card-info {
    height: 18px;
    position: absolute;
    top: -26px;
    left: 7.5px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.3);
    .count-info {
      span {
        display: inline-flex;
        align-items: center;
      }
      span + span {
        margin-left: 6px;
      }
    }
  }
`;

export const MuiCardInfo = styled.div`
  top: -26px;
  left: 7.5px;
  position: absolute;
  &.reverse {
    left: auto;
    right: 7.5px;
  }

  padding: 2px 8px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.3);

  span {
    font-size: 10px;
    display: inline-flex;
    align-items: center;
    svg {
      margin-right: 2px;
    }
  }
  span + span {
    margin-left: 6px;
  }
`;

// ios scroll 시 아래 이슈 방지용으로 fake element 추가
// https://jira.kinemaster.com/projects/KMWD/issues/KMWD-222?filter=allissues
export const FakeElement = styled.div`
  height: 2px;
  background-color: #1f2126;
  position: fixed;
  top: -2px;
  left: 0;
  width: 100%;
  z-index: 1;
`;
